import { deleteAffiliatedCompany } from 'commons/service/bank/affiliatedCompany'
import { WriteHook, useMutationManager } from 'state-manager'

export const useDeleteAffiliatedCompany: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(deleteAffiliatedCompany, opts)
